
const url = window.location.href

const shanghang = {
    index: '72873f6b-e3c6-4ba8-b86f-238f4a032006',
    canyi: 'a54c4485-fb96-4fda-a894-581d9a95a5e3',
    zengche:"2abca2f7-48f4-4a62-88d9-0219ee765788",
    xiandai:"72545f53-f09d-4046-abad-84a76384ad8f",
    chanyijishu:"01d5c079-0c7c-4373-896e-ddaf5a8b34f9"

}

const jishui = {
    index: '28322251-2429-4e75-883b-4ed47eaecb63',
    canyi: 'cbab1536-d230-43b5-a2b6-c972e66bc46b',
    zengche:"69b89d6a-5207-4080-8594-bf471685d91a",
    xiandai:"6a3f9359-6a16-4c4d-83d9-4b68e69bf138",
    chanyijishu:"c93b9c3c-96ed-4c2c-b1be-64f170e711ab"

}

export const countyId = window.location.href.includes('XianYu') ? '350823' :'360822';

export const uid = url.includes('XianYu') ? shanghang : jishui


